import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import Contacts from '@mui/icons-material/Contacts';
import { TextField, Typography } from '@totalsoft/rocket-ui';
import PhoneNumberField from 'components/common/inputs/PhoneNumberTextField';
import { GapGrid } from 'components/common/CommonStyles';
import { GlobalRightsContext } from 'providers/GlobalRightsContext';

const OfferPartnerContactData = ({ t, onPropertyChange, contactMode, validationInfo, disabled, isAssociatedPartner }) => {
  const { shareholderPhone: viewShareholderPhone } = useContext(GlobalRightsContext);

  return (
    <>
      <GapGrid container alignItems='center' my={1} gap={1} direction='row'>
        <Contacts />
        <Typography variant='h6' m={0}>
          {t('OfferEdit.Client.ContactData')}
        </Typography>
      </GapGrid>
      <Grid container spacing={2}>
        {((isAssociatedPartner && viewShareholderPhone) || !isAssociatedPartner) && (
          <Grid item xs={12} sm={12} md={6}>
            <PhoneNumberField
              value={contactMode.phone || ''}
              country={contactMode.phoneCountryCode}
              onChange={onPropertyChange('phone')}
              disabled={disabled}
              error={!!validationInfo.phone}
              helperText={validationInfo.phone}
              name='phone'
              label={t('OfferEdit.Client.MobilePhone')}
            />
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={6}>
          <TextField
            id={'offerPartnerFormCard_email'}
            fullWidth
            value={contactMode.email || ''}
            error={validationInfo.email ? true : false}
            helperText={validationInfo.email && t('Validations.Generic.SeparatedInvalidEmails')}
            name='email'
            label={t('OfferEdit.Client.Email')}
            onChange={onPropertyChange('email')}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </>
  );
};

OfferPartnerContactData.propTypes = {
  t: PropTypes.func.isRequired,
  contactMode: PropTypes.object.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  validationInfo: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  isAssociatedPartner: PropTypes.bool.isRequired
};

export default compose(React.memo, withTranslation())(OfferPartnerContactData);
